import React from 'react';
import "../template-file-css/document-file-template.css";


export const RFS_PsyAlleva = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='RFS_PsyAlleva' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><h3>30-Minute Psychiatric FollowUp / ReEvaluation Note</h3> <br />
                    <h4>Psychiatric Follow-up / Re-Evaluation Progress Note</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Exam Date:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Chart Reviewed:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtExamDate' name='txtExamDate' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='radio' id='cbChartReviewed_Yes' name='cbChartReviewed' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='cbChartReviewed_No' name='cbChartReviewed' className='add-only' value='No' /> No</td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>ADL's:</span>
                    <input type='radio' id='cbAdl_Good' name='cbAdl' className='add-only' value='Good' /> Good &nbsp;&nbsp;
                    <input type='radio' id='cbAdl_Decient' name='cbAdl' className='add-only' value='Decient' /> Decient&nbsp;&nbsp;
                    <input type='radio' id='cbAdl_Other' name='cbAdl' className='add-only' value='Poor' /> Poor</p>

                <p className='w-750'><span className='eleHeader'>Type Of Visit</span>
                    <input type='radio' id='cbTypeOfVisit_Admission' name='cbTypeOfVisit' className='add-only' value='Admission' /> Admission Follow-up&nbsp;&nbsp;
                    <input type='radio' id='cbTypeOfVisit_Weekly' name='cbTypeOfVisit' className='add-only' value='Weekly' /> Weekly&nbsp;&nbsp;
                    <input type='radio' id='cbTypeOfVisit_BiWeekly' name='cbTypeOfVisit' className='add-only' value='BiWeekly' /> Bi-Weekly&nbsp;&nbsp;
                    <input type='radio' id='cbTypeOfVisit_Monthly' name='cbTypeOfVisit' className='add-only' value='Monthly' /> Monthly <br />
                    <input type='radio' id='cbTypeOfVisit_Other' name='cbTypeOfVisit' className='add-only' value='Other' /> Other&nbsp;
                    <input type='text' id='txtTypeOfVisit' name='txtTypeOfVisit' className='add-only w-650 custom-add-only' /></p>

                <p className='w-750'><h4><b>Vitals</b></h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDate' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='time' id='txtTime' name='txtTime' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <span className='eleHeader'>BP systolic</span></td>
                        <td className='w-125'>
                            <span className='eleHeader'>BP diastolic</span></td>
                        <td className='w-125'>
                            <span className='eleHeader'>Temperature</span></td>
                        <td className='w-125'>
                            <span className='eleHeader'>Pulse</span></td>
                        <td className='w-125'>
                            <span className='eleHeader'>Respirations</span></td>
                        <td className='w-125'>
                            <span className='eleHeader'>O2 Saturation</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txtSystolic' name='txtSystolic' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtDiastolic' name='txtDiastolic' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtTemperature' name='txtTemperature' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtPulse' name='txtPulse' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtRespirations' name='txtRespirations' className='add-only' /></td>
                        <td className='w-125'>
                            <input type='text' id='txtSaturation' name='txtSaturation' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b><h4>Height & Weight</h4></b></p>

                <table>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDate_1' name='txtDate_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='time' id='txtTime_1' name='txtTime_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>Height</span></td>
                        <td className='w-187'>
                            <span className='eleHeader'>Weight</span></td>
                        <td className='w-187'>
                            <span className='eleHeader'>Target Body Weight</span></td>
                        <td className='w-187'>
                            <span className='eleHeader'>BMI</span></td>
                        
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='text' id='txtHeight' name='txtHeight' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id='txtWeight' name='txtWeight' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id='txtTargetBodyWeight' name='txtTargetBodyWeight' className='add-only' /></td>
                        <td className='w-187'>
                            <input type='text' id='txtBmi' name='txtBmi' className='add-only' /></td>
                        
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>TBW %</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'># Hours of sleep per night?</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTbw' name='txtTbw' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtHoursOfSleepNight' name='txtHoursOfSleepNight' className='add-only' /></td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicide risk:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSuicideRisk_1' name='cbSuicideRisk_1' className='add-only' value='Isolation' /> Isolation </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSuicideRisk_2' name='cbSuicideRisk_2' className='add-only' value='SI' /> SI </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSuicideRisk_3' name='cbSuicideRisk_3' className='add-only' value='Gesture' /> S gesture </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSuicideRisk_4' name='cbSuicideRisk_4' className='add-only' value='Commanding' /> Commanding AH </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSuicideRisk_5' name='cbSuicideRisk_5' className='add-only' value='Self' /> Self Abuse </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSuicideRisk_6' name='cbSuicideRisk_6' className='add-only' value='Negative' /> Negative</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Assault risk: </span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssaultRisk_1' name='cbAssaultRisk_1' className='add-only' value='Pacing' /> Pacing </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssaultRisk_2' name='cbAssaultRisk_2' className='add-only' value='Irritable' /> Irritable </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssaultRisk_3' name='cbAssaultRisk_3' className='add-only' value='Intrusive' /> Intrusive </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssaultRisk_4' name='cbAssaultRisk_4' className='add-only' value='Loud' /> Loud </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssaultRisk_5' name='cbAssaultRisk_5' className='add-only' value='Threatening' /> Threatening </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssaultRisk_6' name='cbAssaultRisk_6' className='add-only' value='Destruction' /> Destruction of Property</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAssaultRisk_7' name='cbAssaultRisk_7' className='add-only' value='Negative' /> Negative</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Fall risk:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFallRisk_1' name='cbFallRisk_1' className='add-only' value='Generalized' /> Generalized Weakness</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFallRisk_2' name='cbFallRisk_2' className='add-only' value='Neurological' /> Neurological Decit</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFallRisk_3' name='cbFallRisk_3' className='add-only' value='Orthopedic' /> Orthopedic Decit</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFallRisk_4' name='cbFallRisk_4' className='add-only' value='Over' /> Over Sedation </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFallRisk_5' name='cbFallRisk_5' className='add-only' value='Negative' /> Negative</td>
                        <td className='w-250'>
                            &nbsp;</td>
                    </tr>
                </table>

                <p className='w-750'><h3><b>Patient Complaints</b></h3>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Side Effects:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_1' name='cbSideEffects_1' className='add-only' value='Akathisia' /> Akathisia </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_2' name='cbSideEffects_2' className='add-only' value='Dry' /> Dry mouth </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_3' name='cbSideEffects_3' className='add-only' value='Over' /> Over sedation </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_4' name='cbSideEffects_4' className='add-only' value='Insomnia' /> Insomnia </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_5' name='cbSideEffects_5' className='add-only' value='Constipation' /> Constipation</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_6' name='cbSideEffects_6' className='add-only' value='EPS' /> EPS </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_7' name='cbSideEffects_7' className='add-only' value='BlurredVision' /> Blurred Vision</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_8' name='cbSideEffects_8' className='add-only' value='Lightheaded' /> Lightheaded</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_9' name='cbSideEffects_9' className='add-only' value='None' /> None</td>
                        <td className='w-150'>
                            &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSideEffects_10' name='cbSideEffects_10' className='add-only' value='Other' /> Other&nbsp;
                            <input type='text' id='txtSideEffects' name='txtSideEffects' placeholder='Describe' className='add-only w-650 custom-add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><h3><b>Mental Status Exam</b></h3>
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Appearance:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_1' name='cbSideEffects_1' className='add-only' value='Groomed' /> Groomed</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_2' name='cbSideEffects_2' className='add-only' value='Disheveled' /> Disheveled</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_3' name='cbSideEffects_3' className='add-only' value='Sickly' /> Sickly</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_4' name='cbSideEffects_4' className='add-only' value='Unremarkable' /> Unremarkable </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_5' name='cbSideEffects_5' className='add-only' value='Fidgety' /> Fidgety</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_6' name='cbSideEffects_6' className='add-only' value='Restless' /> Restless </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_7' name='cbSideEffects_7' className='add-only' value='Agitated' /> Agitated</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_8' name='cbSideEffects_8' className='add-only' value='Hyperactive' /> Hyperactive</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_9' name='cbSideEffects_9' className='add-only' value='Retarded' /> Retarded PMA</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_10' name='cbSideEffects_10' className='add-only' value='OverlyDramatic' /> Overly Dramatic</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_11' name='cbSideEffects_11' className='add-only' value='Withdrawn' /> Withdrawn </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_12' name='cbSideEffects_12' className='add-only' value='Poor' /> Poor eye contact</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_13' name='cbSideEffects_13' className='add-only' value='Tremors' /> Tremors</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_14' name='cbSideEffects_14' className='add-only' value='Intention' /> Intention</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSideEffects_15' name='cbSideEffects_15' className='add-only' value='Rest' /> Rest</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Orientation:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOrientation_1' name='cbOrientation_1' className='add-only' value='Time' /> Time</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOrientation_2' name='cbOrientation_2' className='add-only' value='Person' /> Person</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOrientation_3' name='cbOrientation_3' className='add-only' value='Place' /> Place</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOrientation_4' name='cbOrientation_4' className='add-only' value='Situation' /> Situation</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Attitude:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_1' name='cbAttitude_1' className='add-only' value='Cooperative' /> Cooperative</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_2' name='cbAttitude_2' className='add-only' value='Evasive' /> Evasive</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_3' name='cbAttitude_3' className='add-only' value='SelfAbsorbed' /> Self-absorbed</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_4' name='cbAttitude_4' className='add-only' value='Passive' /> Passive</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_5' name='cbAttitude_5' className='add-only' value='Hesitant' /> Hesitant</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_6' name='cbAttitude_6' className='add-only' value='Defensive' /> Defensive</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_7' name='cbAttitude_7' className='add-only' value='Arrogant' /> Arrogant</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_8' name='cbAttitude_8' className='add-only' value='Threatening' /> Threatening</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_9' name='cbAttitude_9' className='add-only' value='Manipulative' /> Manipulative</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_10' name='cbAttitude_10' className='add-only' value='Seductive' /> Seductive</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_11' name='cbAttitude_11' className='add-only' value='Demanding' /> Demanding</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_12' name='cbAttitude_12' className='add-only' value='Antagonistic' /> Antagonistic</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_13' name='cbAttitude_13' className='add-only' value='Guarded' /> Guarded</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_14' name='cbAttitude_14' className='add-only' value='Suspicious' /> Suspicious</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_15' name='cbAttitude_15' className='add-only' value='Hostile' /> Hostile</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAttitude_16' name='cbAttitude_16' className='add-only' value='Intimidating' /> Intimidating</td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbAttitude_17' name='cbAttitude_17' className='add-only' value='PassiveAggressive' /> Passive-Aggressive</td>
                        <td className='w-100'>
                            &nbsp;</td>
                        <td className='w-100'>
                            &nbsp;</td>
                        <td className='w-100'>
                            &nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mood:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_1' name='cbMood_1' className='add-only' value='Euthymic' /> Euthymic</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_2' name='cbMood_2' className='add-only' value='Dysphoric' /> Dysphoric</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_3' name='cbMood_3' className='add-only' value='Sad' /> Sad</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_4' name='cbMood_4' className='add-only' value='Jovial' /> Jovial</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_5' name='cbMood_5' className='add-only' value='Anxious' /> Anxious</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_6' name='cbMood_6' className='add-only' value='Fearful' /> Fearful</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_7' name='cbMood_7' className='add-only' value='Despondent' /> Despondent</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_8' name='cbMood_8' className='add-only' value='Irritable' /> Irritable</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_9' name='cbMood_9' className='add-only' value='Angry' /> Angry</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMood_10' name='cbMood_10' className='add-only' value='Euphoric' /> Euphoric</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Affect:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_1' name='cbAffect_1' className='add-only' value='Depressed' /> Depressed</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_2' name='cbAffect_2' className='add-only' value='Congruent' /> Congruent</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_3' name='cbAffect_3' className='add-only' value='Incongruent' /> Incongruent</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_4' name='cbAffect_4' className='add-only' value='Inappropriate' /> Inappropriate</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_5' name='cbAffect_5' className='add-only' value='Restricted' /> Restricted</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_6' name='cbAffect_6' className='add-only' value='Flat' /> Flat</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_7' name='cbAffect_7' className='add-only' value='Blunted' /> Blunted</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_8' name='cbAffect_8' className='add-only' value='Labile' /> Labile</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAffect_9' name='cbAffect_9' className='add-only' value='SlightlyLabile' /> Slightly Labile</td>
                        <td className='w-150'>
                            &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Speech:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_1' name='cbSpeech_1' className='add-only' value='Coherent' /> Coherent</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_2' name='cbSpeech_2' className='add-only' value='Incoherent' /> Incoherent</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_3' name='cbSpeech_3' className='add-only' value='Loud' /> Loud</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_4' name='cbSpeech_4' className='add-only' value='Soft' /> Soft</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_5' name='cbSpeech_5' className='add-only' value='Pressured' /> Pressured</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_6' name='cbSpeech_6' className='add-only' value='SlightlyPressured' /> Slightly pressured</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_7' name='cbSpeech_7' className='add-only' value='Slurred' /> Slurred</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_8' name='cbSpeech_8' className='add-only' value='Sparse' /> Sparse</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_9' name='cbSpeech_9' className='add-only' value='UnderProductive' /> Under productive</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_10' name='cbSpeech_10' className='add-only' value='Nonproductive' /> Nonproductive</td> 
                    </tr>
                    <tr> 
                        <td className='w-150'>
                            <input type='checkbox' id='cbSpeech_11' name='cbSpeech_11' className='add-only' value='Dysarthria' /> Dysarthria</td>
                    </tr>
                </table>

                <table>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Immediate Recall:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbImmediateRecall_1' name='rbImmediateRecall' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'>
                            <input type='radio' id='rbImmediateRecall_2' name='rbImmediateRecall' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'>
                            <input type='radio' id='rbImmediateRecall_3' name='rbImmediateRecall' className='add-only' value='Limited' /> Limited</td>
                        <td className='w-187'>
                            <input type='radio' id='rbImmediateRecall_4' name='rbImmediateRecall' className='add-only' value='Poor' /> Poor</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recent Memory:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbRecentMemory_1' name='rbRecentMemory' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'>
                            <input type='radio' id='rbRecentMemory_2' name='rbRecentMemory' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'>
                            <input type='radio' id='rbRecentMemory_3' name='rbRecentMemory' className='add-only' value='Limited' /> Limited</td>
                        <td className='w-187'>
                            <input type='radio' id='rbRecentMemory_4' name='rbRecentMemory' className='add-only' value='Poor' /> Poor</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Content:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_1' name='cbThoughtContent_1' className='add-only' value='Unremarkable' /> Unremarkable </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_2' name='cbThoughtContent_2' className='add-only' value='Hopeless' /> Hopeless</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_3' name='cbThoughtContent_3' className='add-only' value='Helpless' /> Helpless</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_4' name='cbThoughtContent_4' className='add-only' value='PoorSelfEsteem' /> Poor self esteem </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_5' name='cbThoughtContent_5' className='add-only' value='Guilt' /> Guilt</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_6' name='cbThoughtContent_6' className='add-only' value='Racing' /> Racing </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtContent_7' name='cbThoughtContent_7' className='add-only' value='Paranoid' /> Paranoid</td>
                        <td className='w-150'>
                            &nbsp;</td>
                        <td className='w-150'>
                            &nbsp;</td>
                        <td className='w-150'>
                            &nbsp;</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbThoughtContent_8' name='cbThoughtContent_8' className='add-only' value='Other' /> Other&nbsp;
                            <input type='text' id='txtThoughtContent' name='txtThoughtContent' placeholder='Describe' className='add-only w-650 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Thought Process:</span></td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_1' name='cbThoughtProcess_1' className='add-only' value='GoalOriented' /> Goal Oriented </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_2' name='cbThoughtProcess_2' className='add-only' value='Circumstantial' /> Circumstantial</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_3' name='cbThoughtProcess_3' className='add-only' value='Disorganized' /> Disorganized</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_4' name='cbThoughtProcess_4' className='add-only' value='Concrete' /> Concrete</td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_5' name='cbThoughtProcess_5' className='add-only' value='FlightIdeas' /> Flight of Ideas</td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_6' name='cbThoughtProcess_6' className='add-only' value='Tangential' /> Tangential </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbThoughtProcess_7' name='cbThoughtProcess_7' className='add-only' value='Loose' /> Loose</td>
                        <td className='w-150'>
                            &nbsp;</td>
                        <td className='w-150'>
                            &nbsp;</td>
                        <td className='w-150'>
                            &nbsp;</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Perceptions:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPerceptions_1' name='cbPerceptions_1' className='add-only' value='NoDistortions' /> No distortions</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPerceptions_2' name='cbPerceptions_2' className='add-only' value='Illusions' /> Illusions</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPerceptions_3' name='cbPerceptions_3' className='add-only' value='AppearsHallucinating' /> Appears to be hallucinating</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPerceptions_4' name='cbPerceptions_4' className='add-only' value='Denies' /> Denies</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            Reports:&nbsp;<input type='text' id='txtPerceptions' name='txtPerceptions' className='add-only w-700 custom-add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Suicidal/Homicidal:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidalHomicidal_1' name='cbSuicidalHomicidal_1' className='add-only' value='None' /> None</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidalHomicidal_2' name='cbSuicidalHomicidal_2' className='add-only' value='Ideation' /> Ideation</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSuicidalHomicidal_3' name='cbSuicidalHomicidal_3' className='add-only' value='Intent' /> Intent</td>


                    </tr>
                    <tr>
                        <td className='w-750'>
                            Plan:&nbsp;<input type='text' id='txtSuicidalHomicidal' name='txtSuicidalHomicidal' className='add-only w-700 custom-add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insight:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbInsight_1' name='rbInsight' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInsight_2' name='rbInsight' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInsight_3' name='rbInsight' className='add-only' value='Supercial' /> Supercial</td>
                        <td className='w-187'>
                            <input type='radio' id='rbInsight_4' name='rbInsight' className='add-only' value='Poor' /> Poor</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Judgment:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbJudgment_1' name='rbJudgment' className='add-only' value='Good' /> Good</td>
                        <td className='w-187'>
                            <input type='radio' id='rbJudgment_2' name='rbJudgment' className='add-only' value='Fair' /> Fair</td>
                        <td className='w-187'>
                            <input type='radio' id='rbJudgment_3' name='rbJudgment' className='add-only' value='Limited' /> Limited</td>
                        <td className='w-187'>
                            <input type='radio' id='rbJudgment_4' name='rbJudgment' className='add-only' value='Poor' /> Poor</td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Target Symptoms</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbTargetSymptoms_1' name='cbTargetSymptoms_1' className='add-only' value='Insomnia' /> Insomnia</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbTargetSymptoms_2' name='cbTargetSymptoms_2' className='add-only' value='Risk' /> S/H Risk</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbTargetSymptoms_3' name='cbTargetSymptoms_3' className='add-only' value='Agitation' /> Agitation</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbTargetSymptoms_4' name='cbTargetSymptoms_4' className='add-only' value='Motivation' /> Motivation</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbTargetSymptoms_5' name='cbTargetSymptoms_5' className='add-only' value='Depression' /> Depression</td>

                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbTargetSymptoms_6' name='cbTargetSymptoms_6' className='add-only' value='Hyperactivity' /> Hyperactivity</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbTargetSymptoms_7' name='cbTargetSymptoms_7' className='add-only' value='Aggression' /> Aggression</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbTargetSymptoms_8' name='cbTargetSymptoms_8' className='add-only' value='ChronicPain' /> Chronic Pain</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbTargetSymptoms_9' name='cbTargetSymptoms_9' className='add-only' value='Anxiety' /> Anxiety</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbTargetSymptoms_10' name='cbTargetSymptoms_10' className='add-only' value='Manic' /> Manic</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTargetSymptoms_11' name='cbTargetSymptoms_11' className='add-only' value='Detoxication ' /> Detoxication </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTargetSymptoms_12' name='cbTargetSymptoms_12' className='add-only' value='DischargePlan' /> Discharge Plan</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTargetSymptoms_13' name='cbTargetSymptoms_13' className='add-only' value='Compliance' /> Compliance</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTargetSymptoms_14' name='cbTargetSymptoms_14' className='add-only' value='Symptoms' /> O/C Symptoms</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTargetSymptoms_15' name='cbTargetSymptoms_15' className='add-only' value='ImpulseControl' /> Impulse Control</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTargetSymptoms_16' name='cbTargetSymptoms_16' className='add-only' value='ConfusionMemoryProblems' /> Confusion/Memory Problems</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTargetSymptoms_17' name='cbTargetSymptoms_17' className='add-only' value='NegativeSymptoms' /> NegativeSymptoms</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTargetSymptoms_18' name='cbTargetSymptoms_18' className='add-only' value='DelusionsHallucinations' /> Delusions/Hallucinations</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTargetSymptoms_19' name='cbTargetSymptoms_19' className='add-only' value='PoorInsightJudgment' /> Poor Insight/Judgment</td>

                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Assessment/Continued Stay Criteria</span>
                    <textarea id='txtAssessmentContinuedStayCriteria' name='txtAssessmentContinuedStayCriteria' className='add-only'></textarea></p>

                <p className='w-750'>
                    <span className='eleHeader'>Since last certication, patient continues to need treatment at the assigned ASAM criteria level of psychiatric care for
                        treatment that could potentially improve the patient's symptoms/conditions. Care is required on a daily basis and
                        active treatment is furnished directly by or requiring supervision of treatment facility personnel.
                    </span>
                    <textarea id='txtSinceLastCerticationPatient' name='txtSinceLastCerticationPatient' className='add-only'></textarea></p>

                <p className='w-750'><h4>New Orders</h4></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Precautions:</span></td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbPrecautions_1' name='cbPrecautions_1' className='add-only' value='Suicidal' /> Suicidal</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbPrecautions_2' name='cbPrecautions_2' className='add-only' value='Assault' /> Assault</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbPrecautions_3' name='cbPrecautions_3' className='add-only' value='Elopement' /> Elopement</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbPrecautions_4' name='cbPrecautions_4' className='add-only' value='Fall' /> Fall</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbPrecautions_5' name='cbPrecautions_5' className='add-only' value='Detoxication' /> Detoxication</td>

                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='checkbox' id='cbPrecautions_6' name='cbPrecautions_6' className='add-only' value='Discontinue' /> Discontinue</td>
                        <td className='w-125'>
                            <input type='checkbox' id='cbPrecautions_7' name='cbPrecautions_7' className='add-only' value='None' /> None</td>
                        <td className='w-125'>
                            &nbsp;</td>
                        <td className='w-125'>
                            &nbsp;</td>
                        <td className='w-125'>
                            &nbsp;</td>

                    </tr>
                </table>

                <p className='w-750'><h4><b>Medication Education:</b></h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Risk-benet discussion of different treatment alternatives was discussed with client. Informed consent discussion
                        was completed with client. Reviewed with client: reasons for medication(s), dosing schedule, food/drug interactions,
                        side effects and signs/symptons to report to staff. Client verbalized understanding, and no need for additional
                        information.
                    </span>
                    <textarea id='txtRiskBenetDiscussion' name='txtRiskBenetDiscussion' className='add-only'></textarea></p>

                <p className='w-750'><h4><b>Current Medications:</b></h4></p>

                <p className='w-750'>
                    <span className='eleHeader'>Medications below include all current active orders logged via Doctor's Orders. These may include medications selfreported by the patient that were logged, medication orders entered at the facility, and medications brought to the
                        facility by the patient ordered to be continued upon admission. If the patient is not being treated in a
                        residential/inpatient setting, this list may not be inclusive of all medications taken by the patient outside of the facility.
                    </span>
                    <textarea id='txtMedicationsBelowIncludeAllCurrent' name='txtMedicationsBelowIncludeAllCurrent' className='add-only'></textarea></p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Rationale for Medication change:</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRationalForMedicationChange_1' name='cbRationalForMedicationChange_1' className='add-only' value='NoResponse' /> No Response</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRationalForMedicationChange_2' name='cbRationalForMedicationChange_2' className='add-only' value='LowHighDosage' /> Low/High Dosage</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRationalForMedicationChange_3' name='cbRationalForMedicationChange_3' className='add-only' value='DrugInteraction' /> Drug Interaction</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRationalForMedicationChange_4' name='cbRationalForMedicationChange_4' className='add-only' value='Change' /> Rx Change</td>


                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRationalForMedicationChange_5' name='cbRationalForMedicationChange_5' className='add-only' value='SideEffects' /> Side Effects</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRationalForMedicationChange_6' name='cbRationalForMedicationChange_6' className='add-only' value='Change' /> Dx Change</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRationalForMedicationChange_7' name='cbRationalForMedicationChange_7' className='add-only' value='MedicalCondition' /> Medical Condition</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbRationalForMedicationChange_8' name='cbRationalForMedicationChange_8' className='add-only' value='AdverseReaction' /> Adverse Reaction</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRationalForMedicationChange_9' name='cbRationalForMedicationChange_9' className='add-only' value='NewInformationAvailable' /> New Information Available</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRationalForMedicationChange_10' name='cbRationalForMedicationChange_10' className='add-only' value='LeastEffectiveDosage' /> Least Effective Dosage</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRationalForMedicationChange_11' name='cbRationalForMedicationChange_11' className='add-only' value='Detoxication' /> Detoxication</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRationalForMedicationChange_12' name='cbRationalForMedicationChange_12' className='add-only' value='Na' /> N/A</td>

                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Medication Changes:</span>
                    <input type='checkbox' id='cbMedication_1' name='cbMedication_1' className='add-only' value='None' /> None <br />
                    <textarea id='txtMedicationChanges' name='txtMedicationChanges' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Additional Comments</span>
                    <input type='checkbox' id='cbAdditionalComments_1' name='cbAdditionalComments_1' className='add-only' value='None' /> None <br />
                    <textarea id='txtAdditionalComments' name='txtAdditionalComments' className='add-only'></textarea></p>

                    <p className='w-750'>Martine Phillips, APRN, PMHNP-BC, FNP-BC, CNL FL Lic # 9168061 (Staff), NPI Number 1043766264, 10/28/2022 05:41
                    AM </p>






            </div>
        </form>
    )
}